// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-fY0FZ";
var _3 = "label-6A4Dx";
var _4 = "input-1prsc";
export { _1 as "__esModule", _2 as "container", _3 as "label", _4 as "input" }
export default { "__esModule": _1, "container": _2, "label": _3, "input": _4 }
